export default {
  email: 'suporte@saudecinco.com',
};
